import { useTranslation } from 'react-i18next';

import { Iframe } from '~/components/Iframe';

export function AnomalyDetectionPage() {
  const { t } = useTranslation('marketing');

  return (
    <Iframe
      urlEnvKey="VITE_WMG_EMBED_MARKETING_ANOMALY_DETECTION_DASHBOARD_URL"
      ariaLabel={t('anomalyDashboard.tabs.anomalyDetection')}
    />
  );
}

AnomalyDetectionPage.displayName = 'AnomalyDetectionPage';
